// Copyright (c) 2025 Annadaneshwar Yadawad. All rights reserved.
import React, { useState, useEffect } from 'react';
import { getSubscriberCount } from '../services/notificationService';
import './AdminNotifications.css';

const AdminNotifications = () => {
  const [subscriberCount, setSubscriberCount] = useState(0);

  useEffect(() => {
    fetchSubscriberCount();
    const interval = setInterval(fetchSubscriberCount, 10000); // Poll every 10s
    return () => clearInterval(interval);
  }, []);

  const fetchSubscriberCount = async () => {
    try {
      const count = await getSubscriberCount();
      setSubscriberCount(count);
    } catch (error) {
      console.error('Failed to fetch subscriber count:', error);
    }
  };

  return (
    <div className="service-page">
      <h1>Push Notification Stats</h1>
      <div className="subscriber-stats">
        <p>Active Subscribers: <strong>{subscriberCount}</strong></p>
      </div>
    </div>
  );
};

export default AdminNotifications;
